import { NJModal, NJModalContent } from '@engie-group/fluid-design-system-react';
import './ModalTickets.css';

function ModalTickets({ isOpen, handleClose }) {

    return (
        <NJModal
            id="modalFeedback"
            isOpen={isOpen}
        >
            <NJModalContent
                className='modal-terms-conditions-custom-width'
                id="modalTickets"
                onClose={handleClose}
                title="Tickets"
            >
                <div className='modal-tickets-content'>
                   Please report the issue to your local HR SPOC
                </div>
            </NJModalContent>
        </NJModal>
    )
}

export default ModalTickets;
